import { useState } from 'react'

import { ActionIcon, Menu } from '@mantine/core'
import { EllipsisVertical } from 'lucide-react'
import { VerificationOfEmployment } from 'types/graphql'

import DeleteModal from 'src/components/Overlays/DeleteModal/DeleteModal'

export interface VoEActionsMenuProps {
  voe: VerificationOfEmployment
  iconClassName?: string
  onContact: (voe: VerificationOfEmployment) => void
  onViewDetail: (voe: VerificationOfEmployment) => void
  onDelete: (voeId: string) => Promise<void> | void
  onClick?: (e: React.MouseEvent) => void
  onClose?: () => void // Optional callback to close drawer/modal after actions
}

const VoEActionsMenu = ({
  voe,
  iconClassName = 'h-6 w-6',
  onContact,
  onViewDetail,
  onDelete,
  onClick,
  onClose,
}: VoEActionsMenuProps) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    setIsDeleteModalOpen(true)
  }

  const handleConfirmDelete = async () => {
    await onDelete(voe?.voeId)
    onClose?.()
  }

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false)
  }

  return (
    <>
      <Menu shadow="md" position="bottom-end">
        <Menu.Target>
          <ActionIcon
            variant="subtle"
            color="gray"
            className={iconClassName}
            onClick={(e) => {
              e.stopPropagation()
              onClick?.(e)
            }}
          >
            <EllipsisVertical
              className="stroke-doubleNickel-gray-600"
              size={16}
            />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown className="w-40">
          {(voe.responseContent?.voeResponseContentId ||
            voe.status === 'COMPLETED' ||
            voe.status === 'PENDING_REVIEW') && (
            <Menu.Item
              className="text-doubleNickel-gray-700"
              onClick={(e) => {
                e.stopPropagation()
                onViewDetail(voe)
                onClose?.()
              }}
            >
              View
            </Menu.Item>
          )}
          <Menu.Item
            className="text-doubleNickel-gray-700"
            onClick={(e) => {
              e.stopPropagation()
              onContact(voe)
              onClose?.()
            }}
          >
            Log Contact Attempt
          </Menu.Item>

          <Menu.Item className="text-red-600" onClick={handleDeleteClick}>
            Delete
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>

      <DeleteModal
        opened={isDeleteModalOpen}
        close={handleCloseDeleteModal}
        title="Delete VoE"
        description={`Are you sure you want to delete the VoE for ${
          voe?.companyName || 'this company'
        }? This action cannot be undone.`}
        onDelete={handleConfirmDelete}
      />
    </>
  )
}

export default VoEActionsMenu
